import styled from 'styled-components';
import { Image } from '@podiumhq/design-system';
import LogoTextOnly from './images/logo-text-only.svg';

import TabLogoAndSearch from './TabLogoAndSearch';
import TabPersonal from './TabPersonal';
import TabSystemStatus from './TabSystemStatus';
import TabAdminHamburger from './TabAdminHamburger';

const ViewScaled = ({
  props,
  location,
  currentUser,
  rolePermissions,
  isLocationHome,
}) => {
  return (
    <>
      {isLocationHome ? (
        <>
          <Row>
            <Row>
              <TabAdminHamburger
                {...props}
                currentUser={currentUser}
                isLocationHome={isLocationHome}
              />
              <TabLogoAndSearch
                {...props}
                location={location}
                currentUser={currentUser}
                isLocationHome={isLocationHome}
              />
              <Image
                boxSize="85px"
                height="23px"
                src={LogoTextOnly}
                alt="Podium logo text only"
              />
            </Row>
            <TabPersonal
              currentUser={currentUser}
              rolePermissions={rolePermissions}
              isLocationHome={isLocationHome}
            />
          </Row>
          <ContainerRight>
            <TabSystemStatus />
          </ContainerRight>
        </>
      ) : (
        <Row>
          <Row>
            <TabAdminHamburger
              {...props}
              currentUser={currentUser}
              isLocationHome={isLocationHome}
            />

            <TabLogoAndSearch
              {...props}
              location={location}
              currentUser={currentUser}
              isLocationHome={isLocationHome}
            />
          </Row>
          <Row>
            <TabSystemStatus />
            <ContainerRight>
              <TabPersonal
                currentUser={currentUser}
                rolePermissions={rolePermissions}
                isLocationHome={isLocationHome}
              />
            </ContainerRight>
          </Row>
        </Row>
      )}
    </>
  );
};

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  flex-wrap: wrap;
`;

const ContainerRight = styled.div`
  position: absolute;
  right: 5.5rem;
  @media (max-width: 977px) {
    right: 3rem;
  }
`;

export default ViewScaled;
